<template>
    <v-dialog v-model="show" max-width="640" persistent>
        <v-card class="pa-4">
            <v-card-title class="text-h6">เพิ่มสินค้า</v-card-title>
            <v-card-text class="pt-8">



                <!-- ชื่อ field ตรงกับ AddProduct.vue (หน้าจริง) เพื่อให้ payload/โครงสร้างข้อมูลสอดคล้องกัน -->
                <v-row>
                    <v-text-field v-model="product_name" ref="txtProductName" label="ชื่อสินค้า *" outlined dense
                        :rules="[(v) => !!v || 'กรุณาระบุชื่อสินค้า']"></v-text-field>
                </v-row>
                <v-row>

                    <v-combobox v-model="unit" :items="unitOptions" label="หน่วยสินค้า/บริการ"
                        placeholder="เลือกจากรายการ หรือพิมพ์เอง" outlined dense ref="txtUnit"
                        :rules="[(v) => !!v || 'กรุณาระบุหน่วยสินค้า/บริการ']"></v-combobox>
                </v-row>
                <v-row>

                    <v-text-field v-model="price" label="ราคา" placeholder="ราคา" outlined dense
                        type="number"></v-text-field>

                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="onCancel">ยกเลิก</v-btn>
                <v-btn color="#1565C0" dark @click="onSave">บันทึก</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/services/api";
import { server } from "@/services/constants";
export default {
    name: "AddProductDialog",
    props: {
        value: { type: Boolean, default: false },
        // ข้อความที่ผู้ใช้พิมพ์ไว้ในช่อง autocomplete ก่อนกด "+ เพิ่มเป็นสินค้าใหม่"
        prefillName: { type: String, default: "" },
    },
    data() {
        // MOCKUP ONLY — ยังไม่เรียก API จริง (ดู onSave ด้านล่าง)
        // ตั้งชื่อ field แยกเป็น property เดี่ยวๆ (ไม่ nest ใต้ form) ให้ตรงกับโครงสร้างของ AddProduct.vue (หน้าจริง)
        return {
            valid: false,
            product_name: "",
            product_code: "",
            category_id: "",
            unit: "",
            price: 0,
            categoryOptions: [
                "ค่าบริการที่ปรึกษา",
                "ค่าบริการทางกฎหมาย",
                "ค่าธรรมเนียม/Retainer",
                "อื่นๆ",
            ],
            unitOptions: ["ครั้ง", "ชม.", "วัน", "เดือน", "ปี", "งาน", "คดี"],
        };
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
    },
    watch: {
        value(newVal) {
            if (newVal) {
                this.product_name = this.prefillName || "";
                this.product_code = "";
                this.category_id = "";
                this.unit = "";
                this.price = 0;
            }
        },
    },
    methods: {
        onCancel() {
            this.show = false;
        },
        async onSave() {
            if (!this.product_name) {
                this.$refs["txtProductName"] && this.$refs["txtProductName"].focus();
                return;
            }
            if (!this.unit) {
                this.$refs["txtUnit"] && this.$refs["txtUnit"].focus();
                return;
            }
            const additem = {
                title: this.product_name,
                price: Number(this.price),
                unit: this.unit,
                dept_id: localStorage.getItem(server.DEPARTMENT_ID),
                company_id: localStorage.getItem(server.COMPANYID),
                user_create: localStorage.getItem(server.USER_ID),
            };

            this.$showLoader();
            try {
                await api.billing_expense_addInvTitle(additem);

                // แจ้ง parent ว่าบันทึกลง backend สำเร็จแล้ว พร้อมส่งข้อมูลกลับไปเติมในแถวที่ trigger dialog
                this.$emit("saved", {
                    name: this.product_name,
                    unit: this.unit,
                    rate: Number(this.price),
                });

                this.show = false;
            } catch (error) {
                console.error("billing_expense_addInvTitle error:", error);
                // TODO: แจ้ง error ให้ user เห็น
            } finally {
                this.$hideLoader();
            }
        },
    },
};
</script>

<style scoped>
.dropzone {
    border: 1.5px dashed #90caf9;
    border-radius: 8px;
    padding: 22px;
    text-align: center;
    background: #f5f9ff;
}

.dz-link {
    color: #1565c0;
    font-weight: 600;
    cursor: pointer;
}

.dz-caption {
    font-size: 11px;
    color: #90a4ae;
}
</style>